import { CloudSunIcon, FactoryIcon, GlobeIcon, ShieldAlertIcon, ThermometerSunIcon, WavesIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Module = {
  number: string;
  title: string;
  summary: string;
  icon: LucideIcon;
};

export const modules: Module[] = [
  {
    number: '1',
    title: 'ENSO Fundamentals & Forecast Reading',
    summary: 'How the ocean and atmosphere work together, El Niño, La Niña and neutral phases, Niño 3.4 and ONI, strength categories, alert systems, season codes and how to read an official ENSO bulletin step by step.',
    icon: CloudSunIcon,
  },
  {
    number: '2',
    title: 'Global Impact Map by Region & Sector',
    summary: 'Typical El Niño tendencies in the Americas, Africa, Asia and the Pacific, and how they affect agriculture, oil and gas, energy, mining, ports, logistics and insurance, plus how to screen a multi-site company.',
    icon: GlobeIcon,
  },
  {
    number: '3',
    title: 'Flood, Drainage & Water Management for Industrial Sites',
    summary: 'Rainfall intensity, runoff and peak flow, clean and dirty water separation, channels, pumps, ponds and spillways, slopes and access roads, erosion control, discharge quality and storm-time monitoring.',
    icon: WavesIcon,
  },
  {
    number: '4',
    title: 'Heat, Drought & Energy Supply Risk',
    summary: 'Heat stress and the heat index, work–rest regimes, PPE and first aid, equipment in high temperatures, drought types, the site water balance, alternative water sources, power curtailment and backup fuel.',
    icon: ThermometerSunIcon,
  },
  {
    number: '5',
    title: 'Operational Continuity by Industry',
    summary: 'Continuity planning for mining, oil and gas, agriculture, ports, construction projects and factories: process mapping, buffers, suppliers, people, communities and a preparation calendar.',
    icon: FactoryIcon,
  },
  {
    number: '6',
    title: 'Risk Assessment, Emergency Response & Monitoring',
    summary: 'Hazard identification, risk matrices and registers, bow-tie analysis, risk treatment, early warning thresholds, site weather stations, emergency organization, evacuation and shelter-in-place, communications and insurance basics.',
    icon: ShieldAlertIcon,
  },
];
